import * as Preact from "preact"
// import PixiRenderer from "@frog/source/views/app/renderers/PixiRenderer.view.js"
import Navigation from "@frog/source/models/Navigation.js"
import "@frog/source/views/app/stage/Stage.view.less"
import {loader} from "@frog/source/utility/canvas/gl/render.js"
import timer from "@frog/source/views/app/stage/utility/timer.js"

import sizes from "@frog/source/data/sizes.js"

// VIEW MODELS //

import App from "@frog/source/models/App.js"
import Director from "@frog/source/juice/Director.js"

import pixel from "@frog/source/views/app/stage/utility/pixel.js"
import Geometry from "@frog/source/utility/Geometry.js"
import * as Objdict from "objdict"

import WorldTerrain from "@frog/source/views/app/stage/WorldTerrain.view.js"
import Units from "@frog/source/views/app/stage/Units.view.js"
import ActionArrowLayer from "@frog/source/views/app/stage/ActionArrowLayer.view.js"
import ActionRangeLayer from "@frog/source/views/app/stage/ActionRangeLayer.view.js"
import Particles from "@frog/source/views/app/stage/Particles.view.js"
import Dangerzones from "@frog/source/views/app/stage/Dangerzones.view.js"

function getStage() {
    if(Director.steps[0] != undefined
    && Director.steps[0].stage != undefined) {
        return Director.steps[0].stage
    }
    if(App.game != undefined
    && App.game.encounter != undefined) {
        return App.game.encounter.stage
    }
}

import Colors from "@frog/source/data/colors.js"

const Screens = {EncounterScreen, SplashScreen, TitleScreen, CreditsScreen}
export default function Root() {
    if(Screens[Navigation?.state?.screen] != undefined) {
        if(loader.isPreloaded != true) {
            return {
                "key": "LoadingScreen",
                "type": "container",
                "children": [
                    Blackness(),
                    {
                        "image": require("@frog/source/assets/images/bomber-tactics/loading.png").default,
                        "position": {"x": 64 / 2, "y": 32 - 8},
                    },
                    {
                        "type": "rectangle",
                        "color": Colors.white,
                        "position": {"x": 8, "y": (64 - 8) / 2},
                        "anchor": {"x": 0, "y": 0},
                        "width": 64 - 8 - 8,
                        "height": 8,
                    },
                    {
                        "type": "rectangle",
                        "color": Colors.red,
                        "position": {"x": 8, "y": (64 - 8) / 2},
                        "anchor": {"x": 0, "y": 0},
                        "width": Math.floor((64 - 8 - 8) * (loader.preload ? Math.min(1, loader.count / loader.preload.length) : 0)),
                        "height": 8,
                    }
                ]
            }
        }
        return {
            "key": "Root",
            "type": "container",
            "children": [
                Blackness(),
                Stars(),
                Screens[Navigation.state.screen](),
            ],
        }
    }
}

function Blackness() {
    return {
        "type": "rectangle",
        "color": Colors.black,
        "position": {"x": 0, "y": 0, "stack": -1001},
        "anchor": {"x": 0, "y": 0},
        "width": 64,
        "height": 64,
    }
}

const animation = require("@frog/source/assets/images/bomber-tactics/title/screen/animation.js")
const animation2 = require("@frog/source/assets/images/bomber-tactics/title/start/animation.js")
let firstRenderTime = undefined

import {getImageFromAnimation, isAnimationOver} from "./utility/animation.js"

import Audiomix from "@frog/source/juice/Audiomix.js"
function SplashScreen() {
    return {
        "type": "container",
        "children": [
            {
                "width": 64,
                "height": 64,
                "position": {"x": 0, "y": 0, "stack": -1001},
                "anchor": {"x": 0, "y": 0},
                "type": "rectangle",
                "color": Colors.black,
                "events": {
                    "touchdown": () => {
                        Navigation.go("/game")
                    }
                },
            },
            {
                "position": {"x": (64 / 2), "y": 58 / 2},
                "anchor": {"x": 0.5, "y": 0},
                "image": getImageFromAnimation(animation2, timer.ms),
            }
        ],
    }
}

function TitleScreen() {
    if(firstRenderTime == undefined) {
        firstRenderTime = performance.now()
    }
    return {
        "type": "container",
        "children": [
            {
                "image": getImageFromAnimation(animation, -1 * firstRenderTime + timer.ms),
                "position": {"x": 0, "y": 0},
                "anchor": {"x": 0, "y": 0},
                "events": {
                    "touchdown": () => Navigation.go("/game/encounters/level1")
                },
            },
            isAnimationOver(animation, firstRenderTime) ? {
                "position": {"x": 0, "y": 64},
                "anchor": {"x": 0, "y": 1},
                "image": getImageFromAnimation(animation2, timer.ms),
            } : undefined,
        ]
    }
}

function CreditsScreen() {
    return {
        "image": require("@frog/source/assets/images/bomber-tactics/credits-screen.png").default,
        "anchor": {"x": 0, "y": 0}
    }
}

function EncounterScreen() {
    const stage = getStage()
    if(stage == undefined) return
    return {
        "key": "EncounterScreen",
        "type": "container",
        "children": [
            Stage(stage),
            Interface(),
        ],
    }
}

function Stage(stage) {
    return {
        "key": "Stage",
        "type": "container",
        "position": {
            "x": -1 * (stage.camera || App.game.encounter.selection.camera).position.x,
            "y": -1 * (stage.camera || App.game.encounter.selection.camera).position.y,
        },
        "children": [
            Units(stage),
            WorldTerrain(stage),
            ActionRangeLayer(stage),
            ActionArrowLayer(stage),
            Dangerzones(stage),
            Particles(stage),
            Cursor(stage),
        ]
    }
}

function Cursor(stage) {
    // if(App.game.encounter.selection.position.z == 0) {
    //     return
    // }
    if(App.game.encounter.selection.hoveredUnit != undefined
    || App.game.encounter.selection.selectedUnit != undefined) {
        return
    }
    if(App.game.encounter.selection.position.y == 7) {
        if(App.game.encounter.selection.position.x == 7
        || App.game.encounter.selection.position.x == 6) {
            return
        }
    }
    return {
        "key": "cursor",
        "image": require("@frog/source/assets/images/bomber-tactics/cursor.png").default,
        // "anchor": {"x": 0, "y": 0},
        "position": pixel("cursor", {
            "x": App.game.encounter.selection.position.x,
            "y": App.game.encounter.selection.position.y,
            "z": App.game.encounter.selection.position.z,
        }),
    }
}

function Interface() {
    return {
        "key": "Interface",
        "type": "container",
        "children": [
            EndTurnButton(),
            UndoButton(),
            Modal()
        ]
    }
}

function Modal() {
    if(Navigation?.state?.modal?.type == "failure") {
        return {
            "image": require("@frog/source/assets/images/bomber-tactics/game-over.png").default,
            "anchor": {"x": 0, "y": 0},
        }
    }
    if(Navigation?.state?.modal?.type == "success") {
        return {
            "image": require("@frog/source/assets/images/bomber-tactics/level-clear.png").default,
            "anchor": {"x": 0, "y": 0},
        }
    }
}

function EndTurnButton() {
    return {
        "key": "EndTurnButton",
        "image": require("@frog/source/assets/images/bomber-tactics/ui/done-button.png").default,
        "position": {
            "x": 64 - 4 - 1,
            "y": 64 - 1,
        },
        "events": {
            "touchdown": () => App.game.encounter.endPlayerTurn()
        },
        "width": 8,
        "height": 9,
    }
}

function UndoButton() {
    return {
        "key": "UndoButton",
        "image": require("@frog/source/assets/images/bomber-tactics/ui/undo-button.png").default,
        "position": {
            "x": 64 - 4 - 1 - 8 - 1,
            "y": 64 - 1,
        },
        "events": {
            "touchdown": () => App.game.encounter.undoAction()
        },
    }
}

import Random from "@frog/source/utility/Random.js"
import Loop from "@frog/source/utility/Loop.js"

const colors = [
    // "#E6E56F", "#D4564A", "#54769B", "#E0F8D5"
    Colors.red, Colors.yellow, Colors.blue, Colors.pink
]

const stars = []
for(let index = 0; index < 75; index += 1) {
    stars.push({
        "color": colors[index % colors.length],
        "position": {
            "x": Random.range(0, sizes.canvas.width),
            "y": Random.range(0, sizes.canvas.height),
            "z": Random.range(1, 3)
        },
    })
}
const STAR_SPEED = 0.25
const STAR_SIZE = 1

function Stars() {
    return stars.map((star) => {
        star.position.x -= STAR_SPEED * star.position.z * Loop.delta.f
        if(star.position.x < 0 - STAR_SIZE) {
            star.position.x = sizes.canvas.width + STAR_SIZE
            star.position.y = Random.range(0, sizes.canvas.height)
        }
        return {
            "color": star.color,
            "position": {
                "x": star.position.x,
                "y": star.position.y,
                "stack": -1000,
            },
            "type": "rectangle",
            "width": STAR_SIZE,
            "height": STAR_SIZE,
        }
    })
}
